// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Alpine bootup
import Alpine from "./alpine/imports.js";
import "./Components/drag-slider.js";
import "./Components/booking-module.js";

Alpine();
